import type { Locale } from "../Locale.js";

export function getAlgoliaIndexName(env: string, project: string, locale?: Locale): string {
	let index = `${env}_${project}`;
	if (locale !== undefined) {
		index += `_${locale}`;
	}
	return index;
}
